import { createRouter, createWebHistory } from 'vue-router'
import Apps from '../views/Apps.vue'
import store from '../store'
import Report from '@/views/Report.vue'; // หรือ path ที่ถูกต้องของคุณ

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/Login.vue'),
    meta: {
      title: `เข้าสู่ระบบ`,
    }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../views/Services.vue'),
    meta: {
      title: `บริการงานโสตฯ`
    }
  },
  {
    path: '/',
    name: 'home',
    component: Apps,
    redirect: 'dashboard',
    meta: {
      requiresAuth: true,
      title: `หน้าหลัก`,
      roles: ['admin', 'manager', 'user'],
    },
    children: [
      {
        path: '/test',
        name: 'Test',
        component: () => import('@/views/Test.vue'),
        meta: {
          title: `Test`
        }
      },
      {
        path: '/status_id/:statusId',
        name: 'Wait',
        component: () => import('@/views/Wait.vue'),
        meta: {
          title: `Wait`
        }
      },
      {
        path: '/admin',
        name: 'Admin',
        component: () => import('@/views/Admin.vue'),
        meta: {
          title: `Admin`
        }
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/Profile.vue'),
        meta: {
          title: `ข้อมูลส่วนตัว`
        }
      },
      {
        path: '',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: {
          title: `หนัาหลัก`
        }
      },
      {
        path: '/items',
        name: 'items',
        component: () => import('../views/Items.vue'),
        meta: {
          title: `บริการงานโสตฯ`
        }
      },
      {
        path: '/service-types',
        name: 'service-types',
        component: () => import('../views/Services.vue'),
        meta: {
          title: `ประเภทบริการ`
        }
      },
      {
        path: '/status',
        name: 'Status',
        component: () => import('@/views/Status.vue'),
        meta: {
          title: `Status`
        }
      },
      {
        path: '/report',
        name: 'Report',
        component: Report,
        meta: {
          title: `Report`,
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {

  document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME_EN}`

  const isAuthenticated = store.getters.isAuthenticated;

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {

    next({ name: 'login' });
  } else if (to.matched.some(record => record.meta.requiresGuest) && isAuthenticated) {

    if (to.meta?.roles?.includes(store.state.role)) {
      next()
    } else {
      next({ name: "dashboard" })
    }
  } else {
    next();
  }
});

export default router
